<div class="message-container {{ type }}">
  <div class="message-main">
    <div class="message-title">
      <app-icon class="message-icon" name="notification-{{ type }}"></app-icon>
      <span class="message-title-text">{{ title }}</span>
    </div>

    <div class="message-content">
      {{ content }}
    </div>
  </div>

  @if (showClose) {
  <button class="message-close-btn" (click)="onClose()">
    <app-icon name="close-notification" size="original"></app-icon>
  </button>
  }
</div>
